module.exports = __webpack_public_path__ + "static/media/challenge.185ba9fc.png";